import { PaymentMethod } from "../steps/FundingSource";

export const minUSDAmountByPaymentMethod: Record<
  Exclude<PaymentMethod, "debit_card_alias">,
  number
> = {
  wallet: 0.5,
  external_wallet: 0.5,
  coinbase: 0.5,
  coinbase_app: 20,
  transfer: 0.5,
  fiat: 25,
  interac: 75,
  onramp: 2,
  onramper: 10,
} as const;
